import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import WpImage from "../components/WpImage";
import Link from "../components/Link";
import ArrowIcon from "../icons/arrow-16.svg";
import ContainerWide from "../components/ContainerWide";
import { VectorBackground } from "../components/VectorBackground";
import ButtonText from "../components/ButtonText";

const SolutionsOverview = ({ header, description, items, slug }) => {
    if (!items || items.length === 0) return null;

    return (
        <ContainerWide className="solutions-overview" id={slug || "solutions"}>
            <div className="solutions-overview__container">
                <VectorBackground gradient />
                <Container>
                    {header && (
                        <Row>
                            <Col xs={24}>
                                <h2
                                    className="solutions-overview__header"
                                    dangerouslySetInnerHTML={{ __html: header }}
                                />
                            </Col>
                        </Row>
                    )}
                    {description && (
                        <Row>
                            <Col
                                xs={24}
                                className="solutions-overview__description-wrapper"
                            >
                                <p
                                    className="solutions-overview__description"
                                    dangerouslySetInnerHTML={{
                                        __html: description,
                                    }}
                                />
                            </Col>
                        </Row>
                    )}
                    <Row className="solutions-overview__row">
                        {items.map((item, index) => (
                            <Col
                                key={index}
                                xs={24}
                                className="solutions-overview__col"
                            >
                                <div className="solutions-overview__card">
                                    <div className="solutions-overview__content">
                                        {item.title && (
                                            <h3
                                                className="solutions-overview__title"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.title,
                                                }}
                                            />
                                        )}
                                        {item.description && (
                                            <div
                                                className="solutions-overview__text"
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}
                                            />
                                        )}
                                        {(item.button?.link ||
                                            item.secondButton?.link) && (
                                            <div className="solutions-overview__buttons">
                                                {item.button?.link && (
                                                    <ButtonText
                                                        variant={`${item.button.variant}`}
                                                        {...item.button.link}
                                                    >
                                                        {item.button.link.title}
                                                    </ButtonText>
                                                )}
                                                {item.secondButton?.link && (
                                                    <ButtonText
                                                        variant={`${item.secondButton.variant}`}
                                                        {...item.secondButton
                                                            .link}
                                                    >
                                                        {
                                                            item.secondButton
                                                                .link.title
                                                        }
                                                    </ButtonText>
                                                )}
                                            </div>
                                        )}
                                    </div>

                                    {item.image && (
                                        <WpImage
                                            image={item.image}
                                            className="solutions-overview__image"
                                            objectFit="cover"
                                        />
                                    )}
                                </div>
                            </Col>
                        ))}
                    </Row>
                </Container>
            </div>
        </ContainerWide>
    );
};

export default SolutionsOverview;
